import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {Observable} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {PortfolioService} from "../../pages/portfolio/portfolio.service";
import {CompanyModel} from "../../shared/models/company.model";
import {UploadDialogComponent} from "../upload-dialog/upload-dialog.component";
import { MaterialModule } from "src/app/app.materials";
import { CimDatepickerComponent } from "../cim-datepicker/cim-datepicker.component";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-advanced-filter-with-select',
  templateUrl: './advanced-filter-with-select.component.html',
  styleUrls: ['./advanced-filter-with-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MaterialModule, CimDatepickerComponent, FormsModule, CommonModule],
  standalone: true,
})
export class AdvancedFilterWithSelectComponent implements OnInit {
  @Input() filterLists: any = {
    markets: [],
    regions: [],
    countries: [],
    sectors: [],
    industries: [],
    expectedResults: null,
  }
  @Input() meta: any = {};
  @Input() visibilityList: any = {};

  @Output() fetchCompanies: EventEmitter<any> = new EventEmitter<any>();
  @Output() companySelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileUploaded: EventEmitter<any> = new EventEmitter<any>();


  selectedFilter: any = {
    market_id: [],
    region_id: [],
    country_id: [],
    sector_id: [],
    industry_id: [],
    currency_id: [],
    searchTerm: null
  }

  textSearchResult: any[] = [];

  showAdvancedFilters = false;

  constructor(
    private service: PortfolioService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  collectFilters() {
    const filter:any = {
      filters: {
      }
    }
    if (this.selectedFilter.market_id && this.selectedFilter.market_id.length) {
      filter.filters.market_id = this.selectedFilter.market_id;
    }
    if (this.selectedFilter.region_id && this.selectedFilter.region_id.length) {
      filter.filters.region_id = this.selectedFilter.region_id;
    }
    if (this.selectedFilter.country_id && this.selectedFilter.country_id.length) {
      filter.filters.country_id = this.selectedFilter.country_id;
    }
    if (this.selectedFilter.sector_id && this.selectedFilter.sector_id.length) {
      filter.filters.sector_id = this.selectedFilter.sector_id;
    }
    if (this.selectedFilter.industry_id && this.selectedFilter.industry_id.length) {
      filter.filters.industry_id = this.selectedFilter.industry_id;
    }
    if (this.selectedFilter.searchTerm) {
      filter.searchTerm = this.selectedFilter.searchTerm;
    }
    if (this.selectedFilter.start_date) {
      filter.filters.start_date = this.selectedFilter.start_date
    }
    if (this.selectedFilter.end_date) {
      filter.filters.end_date = this.selectedFilter.end_date
    }
    if (this.selectedFilter.currency_id && this.selectedFilter.currency_id.length) {
      filter.filters.currency_id = this.selectedFilter.currency_id
    }
    filter.page = 1;
    return filter;
  }

  onFilterChange() {
    this.fetchCompanies.emit(this.collectFilters());
  }

  onFetchBtnClick() {
    this.fetchCompanies.emit(this.collectFilters())
  }

  onRegionChange() {
    this.selectedFilter.country_id = [];
    this.selectedFilter.sector_id = [];
    this.selectedFilter.industry_id = [];

    this.filterLists.countries = [];
    this.filterLists.sectors = [];
    this.filterLists.industries = [];

    this.onFilterChange();
  }

  onCountryChange() {
    this.selectedFilter.sector_id = [];
    this.selectedFilter.industry_id = [];

    this.filterLists.sectors = [];
    this.filterLists.industries = [];
    this.onFilterChange();
  }

  onSectorChange() {
    this.selectedFilter.industry_ids = [];
    this.filterLists.industries = [];
    this.onFilterChange();
  }

  onIndustryChange() {
    this.onFilterChange();
  }

  onCompanySelect(company) {
    this.selectedFilter.searchTerm = null;
    this.companySelect.emit(company);
  }

  onUploadClick() {
    const dialogRef = this.dialog.open(UploadDialogComponent, {
      minWidth: '400px',
      maxWidth: '500px'
    });
    dialogRef.afterClosed().subscribe((resp: CompanyModel[]) => {
      if (resp.length) {
        this.fileUploaded.emit(resp);
      }
    })
  }
}
